import { parseAbiParameters } from "abitype";
import { DepositDataAbi, SendParam } from "logic/utils";
import { useMemo } from "react";
import { encodeAbiParameters, zeroAddress } from "viem";

interface useDepositParamsParams {
  usdaiAmountUnits: bigint;
  dstChainSP: SendParam;
}

export function useDepositParams(params: useDepositParamsParams) {
  const { usdaiAmountUnits, dstChainSP } = params;

  const { depositParamsData, depositParams } = useMemo(() => {
    const minUsdaiUnits = usdaiAmountUnits;

    const abi = DepositDataAbi;
    const depositParams = [minUsdaiUnits, zeroAddress, dstChainSP, 0n] as const;
    const depositParamsData = encodeAbiParameters(parseAbiParameters(abi), depositParams);

    return { depositParamsData, depositParams };
  }, [dstChainSP, usdaiAmountUnits]);

  return { depositParamsData, depositParams };
}
